import { render, staticRenderFns } from "./IndividualQuestionnaire.vue?vue&type=template&id=543272aa&scoped=true&"
import script from "./IndividualQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./IndividualQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./IndividualQuestionnaire.vue?vue&type=style&index=0&id=543272aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543272aa",
  null
  
)

export default component.exports